export const isInternalUser = (email: string = '') => {
  if (email.endsWith('@aavaz.ai')) {
    return true;
  }
  const domain = email.substring(email.lastIndexOf('@') + 1);
  return domain.startsWith('enterpret.');
};
